<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				<FormItem label="合同编号" prop="contractCode" class="sj">
					<Input v-model="formValidate.contractCode" placeholder="请输入合同编号"></Input>
				</FormItem>
				<FormItem label="总金额" prop="money" class="sj">
					<Input v-model="formValidate.money" placeholder="请输入总价"></Input>
				</FormItem>
				
				<FormItem label="货道数量" prop="money" class="sj">
					<Input v-model="formValidate.number" placeholder="请输入货道数量" ></Input>
				</FormItem>
				<FormItem label="供应商" prop="operId" class="sj" >
					<Select v-model="formValidate.operId" placeholder="请选择运营商" disabled >
						<Option v-for="(item,i) in opers" :key="i" :value="item.id">{{item.companyName}}</Option>

					</Select>
				</FormItem>
				
				<!-- <FormItem label="开始时间" prop="beginDateTime" class="sj">
					<DatePicker v-model="formValidate.beginDateTime" :editable="false" type="datetime" placeholder="Select date and time" style="width: 200px"></DatePicker>
				</FormItem>
				<FormItem label="结束时间" prop="overDateTime" class="sj">
					<DatePicker v-model="formValidate.overDateTime" :editable="false" type="datetime" placeholder="Select date and time" style="width: 200px"></DatePicker>
				</FormItem> -->
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					contractCode: '',
					money: '',
					number: '',
					operId: '',
					beginDateTime:'',
					overDateTime:''
				},
				opers:[],
				ruleValidate: {
					contractCode: [{
						required: true,
						message: '合同编号不能为空！！！',
						trigger: 'blur'
					}],
					money: [{
						required: true,
						message: '总价不能为空！！！',
						trigger: 'blur'
					}],
					operId: [{
						required: true,
						message: '请选择供应商！！！',
						trigger: 'blur'
					}],
					number: [{
						required: true,
						message: '请输入货道数量！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				if(_this.formValidate.overDateTime=="" || _this.formValidate.beginDateTime==""){
					_this.$Message.error('请选择开始或者结束时间!');
					return ;
				}
				this.$refs[name].validate((valid) => {
					if (valid) {
						if(escape(this.formValidate.contractCode).indexOf("%u")>=0){
							_this.$Message.error('订单号不能包含中文!');
						   return ;
						}
						let aa= {
							id:_this.formValidate.id,
							contractCode: _this.formValidate.contractCode,
							money: _this.formValidate.money*100,
							number: _this.formValidate.number,
							operId: _this.formValidate.operId,
							beginDateTime:_this.formValidate.beginDateTime,
							overDateTime:_this.formValidate.overDateTime
						}
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/fin/report/aisle/contract/update',
						    data: aa,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
					
					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			},
			queryAlliance() {
				let _this = this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/plat/oper/page',
				    data: {page: 0,size: 1000},
					_this: _this,
					success: function(data) {
						_this.opers = data.opers.content
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			ajax() {
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/aisle/contract/get',
				    data: {id: _this.formValidate.id},
					_this: _this,
					success: function(data) {
						_this.formValidate = data.order
						_this.formValidate.money=_this.formValidate.money/100+''
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
		created() { //请求数据
			this.formValidate.id = this.$route.query.id
			this.ajax()
			this.queryAlliance()
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/macAisleOrder/update.vue